<template>
  <v-text-field
    v-model="internalValue"
    :append-icon="visibilityIcon"
    :type="inputType"
    v-bind="$attrs"
    @click:append="toggleVisibility"
    @keydown="e => $emit('keydown', e)"
    @focus="e => $emit('focus', e)"
    @blur="e => $emit('blur', e)"
  />
</template>

<script>
export default {
  name: 'PasswordField',
  inheritAttrs: false,

  model: {
    prop: 'inputValue',
    event: 'input',
  },

  props: {
    // This is actually used as it is being passed to `v-text-field` via `$attrs`
    /* eslint-disable vue/no-unused-properties */
    inputValue: {
      type: String,
      required: true,
    },
    /* eslint-enable */
  },

  data () {
    return {
      isPasswordVisible: false,
      lazyValue: '',
    }
  },

  computed: {
    inputType () {
      return this.isPasswordVisible ? 'text' : 'password'
    },

    internalValue: {
      get () {
        return this.lazyValue
      },

      set (val) {
        this.lazyValue = val
        this.$emit('input', this.lazyValue)
      },
    },

    visibilityIcon () {
      return this.isPasswordVisible ? 'mdi-eye' : 'mdi-eye-off'
    },
  },

  watch: {
    inputValue (newVal, oldVal) {
      if (newVal === oldVal) return
      this.lazyValue = newVal
    },
  },

  methods: {
    toggleVisibility () {
      this.isPasswordVisible = !this.isPasswordVisible
    },
  },
}
</script>
